export function trimNews() {
    const news = [...document.querySelectorAll(".c-news__list__item")];

    news.forEach((el) => {
        const txt = el.querySelector(".txt");

        if (txt) {
            const txtstr = txt.textContent;
            const MAX_LENGTH = window.innerWidth <= 834 ? 32 : 44; //文字数上限
            let modStr = ""; //カット後の文字列

            if (txtstr.length > MAX_LENGTH) {
                modStr = txtstr.substr(0, MAX_LENGTH) + "…";
                txt.textContent = modStr;
            }
        }
    });
}
